const asciiArt = ` ++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++
++++++++++++++++---+++++++++++++
+++++++++++-...    ....-++++++++
+++++++++..   .....    -++++++++
++++++++.   .-++++-    -++++++++
+++++++-    -+++++-    -++++++++
+++++++.   .++++++-    -++++++++
+++++++.   .++++++.    -++++++++
+++++++.    .++++..    .++++++++
++++++++.     .. .-.   .++++++++
+++++++++.      .-+.    -+++++++
+++++++++++----+++++++++++++++++
++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++
 ++++++++++++++++++++++++++++++

Make a smart move https://www.akina.health/en/contact
 `;

export function akinaAsciiArt() {
  console.info(asciiArt);
}
